import React, {useState} from "react";
import {EmployeeDashboardProps} from "@widgets/timeRegistration/EmployeeDashboard";
import {EmployeeStatus} from "@/data/entities/employee";
import {FormattedMessage, useIntl} from "react-intl";
import {Button, useNotifications} from "peggirkit";
import {useMutation} from "@tanstack/react-query";
import {notifyDanger} from "@/utils/NotifyUtils";
import {api} from "@/data/api";

type Props = EmployeeDashboardProps & {
    employee: EmployeeStatus,
};

const ClockInOption = ({employee, setEmployee}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const [loading, setLoading] = useState(false);
    const {mutate} = useMutation({
        mutationFn: (code: string) => api.employee.clockIn(code),
        onSuccess: (updatedEmployee: EmployeeStatus) => setEmployee(updatedEmployee),
        onError: () => notifyDanger(intl.formatMessage({id: "systemError"}), notify),
        onSettled: () => setLoading(false)
    });

    return (
        <Button
            buttonAction={{
                as: "button",
                actionProps: {
                    onClick: () => mutate(employee.code),
                },
            }}
            align={"center"}
            width={"w-full"}
            color={"primary"}
            size={"lg"}
            loading={loading}
        >
            <FormattedMessage id={"clockIn"}/>
        </Button>
    );
};

export default ClockInOption;